import Head from 'next/head';
import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { getStoreImageUrl } from 'lib/image';
import { toAbsoluteLink, toStoreCouponsLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { markup } from 'lib/utils';

const jsonLdItemList = (stores) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: stores.map(({ storeName, storeSlug }, index) => ({
    '@type': 'SiteNavigationElement',
    '@id': '#navigation',
    name: storeName,
    url: toAbsoluteLink(toStoreCouponsLink(storeSlug)),
    position: index + 1,
  })),
});

const HighlightedCouponsStores = ({ stores }) => (
  <>
    <Head>
      <script
        dangerouslySetInnerHTML={markup(JSON.stringify(jsonLdItemList(stores)))}
        type="application/ld+json"
      />
    </Head>
    <div>
      <Heading as="h2" className="mb-6 lg:mb-8" size="size5">
        {placeholder('titles.mainStores')}
      </Heading>
      <div className="grid grid-cols-2 gap-x-2 gap-y-4 md:grid-cols-3 lg:grid-cols-4">
        {stores.map(({ storeImage, storeName, storeSlug }) => (
          <NextLink
            key={storeSlug}
            href={toStoreCouponsLink(storeSlug)}
            prefetch={false}
            passHref
          >
            <Box
              as="a"
              className="w-fit flex-row items-center gap-4 rounded-4 p-4 transition hover:shadow-md"
            >
              <Image
                alt={`Imagem da loja ${storeName}`}
                className="h-auto rounded-full"
                height={32}
                sizes="32px"
                src={getStoreImageUrl(storeImage, 32)}
                srcSet={`
                  ${getStoreImageUrl(storeImage, 60)} 60w,
                  ${getStoreImageUrl(storeImage, 80)} 80w,
                  ${getStoreImageUrl(storeImage, 120)} 120w
                `}
                width={32}
              />
              <Text className="text-center" size="size1">
                {storeName}
              </Text>
            </Box>
          </NextLink>
        ))}
      </div>
    </div>
  </>
);

HighlightedCouponsStores.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeImage: PropTypes.string.isRequired,
      storeSlug: PropTypes.string.isRequired,
      storeName: PropTypes.string.isRequired,
    })
  ),
};

export default HighlightedCouponsStores;
